import { Tag, TagCategory } from '../../components/inputs/TagInsertInput'
import { ActionType, NotificatieType } from '../../types/apiRequests'

export const NOTIFICATION_TYPE_CHOICES = [
  { id: NotificatieType.BEWAARTERMIJN_VERLENGD, name: 'Bewaartermijn verlengd' },
  { id: NotificatieType.DOCUMENT_GEWIJZIGD, name: 'Document gewijzigd' },
  { id: NotificatieType.DOCUMENT_TOEGEVOEGD, name: 'Document toegevoegd' },
  { id: NotificatieType.DOCUMENT_VERWIJDERD, name: 'Document verwijderd' },
  { id: NotificatieType.EINDE_BEWAARTERMIJN_NADERT, name: 'Einde bewaartermijn nadert' },
  { id: NotificatieType.INITIATOR_GEWIJZIGD, name: 'Initiator gewijzigd' },
  { id: NotificatieType.KETENPARTNER_VERWIJDERD, name: 'Ketenpartner verwijderd' },
  { id: NotificatieType.NIEUW_BERICHT, name: 'Nieuw bericht' },
  { id: NotificatieType.PRIVILEGE_VOOR_KETENPARTNER_AANGEPAST, name: 'Privilege voor ketenpartner aangepast' },
  { id: NotificatieType.RECHTEN_OP_DOCUMENT_AANGEPAST, name: 'Rechten op document aangepast' },
  { id: NotificatieType.SAMENWERKING_OPGEHAALD, name: 'Samenwerking opgehaald' },
  { id: NotificatieType.SAMENWERKING_GESTOPT, name: 'Samenwerking gestopt' },
  { id: NotificatieType.SAMENWERKING_GEWIJZIGD, name: 'Samenwerking gewijzigd' },
  { id: NotificatieType.SAMENWERKING_WORDT_GESLOTEN, name: 'Samenwerking wordt gesloten' },
  { id: NotificatieType.STATUS_ACTIEVERZOEK_GEWIJZIGD, name: 'Status actieverzoek gewijzigd' },
  { id: NotificatieType.UITNODIGING_KETENPARTNER, name: 'Uitnodiging ketenpartner' },
  { id: NotificatieType.VERZOEK_OPHALEN_MISLUKT, name: 'Verzoek ophalen mislukt' },
  { id: NotificatieType.VERZOEK_OPHALEN_GESLAAGD, name: 'Verzoek ophalen geslaagd' },
]

export const ACTION_TYPE_LABELS: Record<ActionType, string> = {
  [ActionType.CreateCase]: 'Zaak aanmaken',
  [ActionType.AddNote]: 'Notitie toevoegen',
  [ActionType.SyncDocument]: 'Document synchroniseren',
  [ActionType.SendMessage]: 'Bericht versturen via zaak',
  [ActionType.SendToUrl]: 'Verstuur naar URL',
  [ActionType.Archive]: 'Samenwerking archiveren',
}

const NO_MAPPING_OPTION = { value: '', label: '- Geen mapping -' }

const SAMENWERKING_OPTIONS = [
  { value: 'samenwerking.samenwerkingId', label: 'ID' },
  { value: 'samenwerking.titel', label: 'Titel' },
  { value: 'samenwerking.beschrijving', label: 'Beschrijving' },
  { value: 'samenwerking.bronVerzoek', label: 'Bron verzoek' },
  { value: 'samenwerking.contactpersoonEmailadres', label: 'Email contactpersoon' },
  { value: 'samenwerking.contactpersoonNaam', label: 'Naam contactpersoon' },
  { value: 'samenwerking.contactpersoonTelefoonnummer', label: 'Telefoon contactpersoon' },
  { value: 'samenwerking.globaleLocatie', label: 'Globale locatie' },
  { value: 'samenwerking.kenmerkSysteem', label: 'Kenmerk systeem' },
  { value: 'samenwerking.nummerBinnenSysteem', label: 'Nummer binnen systeem' },
  { value: 'samenwerking.oloVerzoeknummer', label: 'OLO verzoeknummer' },
  { value: 'samenwerking.samenwerkDoel', label: 'Doel' },
  { value: 'samenwerking.typeVerzoek', label: 'Type verzoek' },
]

const ACTIEVERZOEK_OPTIONS = [
  { value: 'actieverzoek.actieverzoekId', label: 'ID' },
  { value: 'actieverzoek.titel', label: 'Titel' },
  { value: 'actieverzoek.omschrijving', label: 'Omschrijving' },
  { value: 'actieverzoek.melding', label: 'Melding' },
  { value: 'actieverzoek.ontvanger', label: 'Ontvanger' },
  { value: 'actieverzoek.ontvangerNaam', label: 'Ontvanger naam' },
  { value: 'actieverzoek.productId', label: 'Product ID' },
  { value: 'actieverzoek.samenwerkingId', label: 'Samenwerking ID' },
  { value: 'actieverzoek.status', label: 'Status' },
  { value: 'actieverzoek.zender', label: 'Zender' },
  { value: 'actieverzoek.zenderNaam', label: 'Zender naam' },
]

const DOCUMENT_OPTIONS = [
  { value: 'document.documentId', label: 'ID' },
  { value: 'document.documentNaam', label: 'Naam' },
  { value: 'document.documentOmschrijving', label: 'Omschrijving' },
  { value: 'document.documentType', label: 'Type' },
  { value: 'document.vertrouwelijkheid', label: 'Vertrouwelijkheid' },
  { value: 'document.status', label: 'Status' },
]

const NOTIFICATIE_OPTIONS = [
  { value: 'notificatie.notificatieTitel', label: 'Titel' },
  { value: 'notificatie.notificatieTekst', label: 'Tekst' },
  { value: 'notificatie.eventInitiatorNaam', label: 'Initiator naam' },
  { value: 'notificatie.deelnemerNaam', label: 'Deelnemer naam' },
]

const TAG_CATEGORIES: TagCategory[] = [
  { id: 'samenwerking', label: 'Samenwerking' },
  { id: 'notificatie', label: 'Notificatie' },
  { id: 'actieverzoek', label: 'Actieverzoek' },
  { id: 'document', label: 'Document' },
]

const POPULAR_TAG_VALUES = [
  'samenwerking.titel',
  'samenwerking.beschrijving',
  'notificatie.notificatieTitel',
  'notificatie.notificatieTekst',
]

const optionsToTags = (options: Array<{ value: string; label: string }>, categoryId: string): Tag[] =>
  options.map((opt) => ({
    id: opt.value,
    label: opt.label,
    value: opt.value,
    categoryId,
    popular: POPULAR_TAG_VALUES.includes(opt.value),
  }))

export const ALL_TAGS: Tag[] = [
  ...optionsToTags(SAMENWERKING_OPTIONS, 'samenwerking'),
  ...optionsToTags(NOTIFICATIE_OPTIONS, 'notificatie'),
  ...optionsToTags(ACTIEVERZOEK_OPTIONS, 'actieverzoek'),
  ...optionsToTags(DOCUMENT_OPTIONS, 'document'),
]

const prefixOptions = (options: Array<{ value: string; label: string }>, prefix: string) =>
  options.map((o) => ({ ...o, label: `${prefix}: ${o.label}` }))

const MAPPING_BASE = [
  NO_MAPPING_OPTION,
  ...prefixOptions(SAMENWERKING_OPTIONS, 'Samenwerking'),
  ...prefixOptions(NOTIFICATIE_OPTIONS, 'Notificatie'),
]

export const getMappingSourceOptions = (notificationType?: NotificatieType) => {
  if (notificationType === NotificatieType.STATUS_ACTIEVERZOEK_GEWIJZIGD) {
    return [...MAPPING_BASE, ...prefixOptions(ACTIEVERZOEK_OPTIONS, 'Actieverzoek')]
  }
  if (notificationType?.startsWith('DOCUMENT_')) {
    return [...MAPPING_BASE, ...prefixOptions(DOCUMENT_OPTIONS, 'Document')]
  }
  return MAPPING_BASE
}

export const ACTIEVERZOEK_STATUS_OPTIONS = [
  { value: 'OPEN', label: 'Open' },
  { value: 'IN_BEHANDELING', label: 'In behandeling' },
  { value: 'GEWEIGERD', label: 'Geweigerd' },
  { value: 'INGETROKKEN', label: 'Ingetrokken' },
  { value: 'GEREEDGEMELD', label: 'Gereedgemeld' },
  { value: 'GEREED', label: 'Gereed' },
]

export const TEMPLATE_PLACEHOLDER_HELP = 'Gebruik het {{ }} icoon om tags in te voegen als placeholders'

export interface CatalogEntry {
  id: string
  attributes: {
    type: string
    name: string
    active: boolean
  }
}

export interface CustomField {
  is_group: boolean
  attribute_magic_string?: string
  title: string
  attribute_type?: string
}

export interface CasetypeResponse {
  data?: {
    attributes?: {
      phases?: Array<{
        custom_fields?: CustomField[]
      }>
    }
  }
}

export interface HeaderRow {
  key: string
  value: string
}

export type CustomFieldWithMapping = CustomField & {
  attribute_magic_string: string
}

export const hasAttributeMagicString = (
  field: CustomField
): field is CustomFieldWithMapping => !field.is_group && typeof field.attribute_magic_string === 'string'

export const parseHeaderRows = (headersJson?: string): HeaderRow[] => {
  try {
    const parsed: unknown = JSON.parse(headersJson || '{}')
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return []
    }

    return Object.entries(parsed).map(([key, value]) => ({
      key,
      value: String(value),
    }))
  } catch {
    return []
  }
}

export const getTemplateMeta = (notificationType?: NotificatieType) => {
  const categoryIds = new Set(['samenwerking', 'notificatie'])
  if (notificationType === NotificatieType.STATUS_ACTIEVERZOEK_GEWIJZIGD) categoryIds.add('actieverzoek')
  if (notificationType?.startsWith('DOCUMENT_')) categoryIds.add('document')
  return {
    templateTags: ALL_TAGS.filter((t) => categoryIds.has(t.categoryId)),
    templateCategories: TAG_CATEGORIES.filter((c) => categoryIds.has(c.id)),
  }
}
